// Insights
export const InsightsPdfGenerating = 'InsightsPdfGenerating';
export const InsightsPdfGenerationFailed = 'InsightsPdfGenerationFailed';
export const InsightsPdfReady = 'insightsPdfReady';

// Review document
export const ReviewPdfGenerating = 'reviewPdfGenerating';
export const ReviewPdfGenerationFailed = 'reviewPdfGenerationFailed';
export const ReviewPdfReady = 'reviewPdfReady';

// Amp
export const AmpNotFound = 'ampNotFound';
export const DuplicateAmpStarted = 'duplicateAmpStarted';
export const DuplicateAmpSucceeded = 'duplicateAmpSucceeded';
export const PreviewOnlyAmp = 'previewOnlyAmp';

// General
export const CopiedToClipboard = 'copiedToClipboard';
export const MediaUploadFailed = 'mediaUploadFailed';
export const ResentInvitation = 'resentInvitation';

export const notifications = {
  // Insights
  [InsightsPdfGenerating]: () => ({
    type: 'loading',
    title: 'Generating Insights Document. You’ll be notified when it is ready.',
    description: 'Be aware that any changes made after generation has started, will not be included.',
    duration: '6000',
  }),
  [InsightsPdfGenerationFailed]: ({ ampName }) => ({
    type: 'warning',
    title: `Your Insights Document for ${ampName} failed to generate`,
    description: 'Please try again',
    closable: true,
    duration: '-1',
  }),
  [InsightsPdfReady]: ({ ampName, actions }) => ({
    type: 'success',
    title: `Your Insights Document for ${ampName} is ready `,
    closable: true,
    duration: '-1',
    actions,
  }),

  // Review Document
  [ReviewPdfGenerating]: () => ({
    type: 'loading',
    title: 'Generating Review Document. You’ll be notified when it is ready.',
    description: 'Be aware that any changes made after generation has started, will not be included.',
    duration: '6000',
  }),
  [ReviewPdfGenerationFailed]: ({ ampName }) => ({
    type: 'warning',
    title: `Your Review Document for ${ampName} failed to generate`,
    description: 'Please try again',
    closable: true,
    duration: '-1',
  }),
  [ReviewPdfReady]: ({ ampName, actions }) => ({
    type: 'success',
    title: `Your Review Document for ${ampName} is ready `,
    closable: true,
    duration: '-1',
    actions,
  }),

  // Amp
  [AmpNotFound]: ({ organizationName }) => ({
    type: 'warning',
    title: `We could not find this Amp in ${
      organizationName || 'this organization'
    }. Switch to another organization and try to access the link again.`,
    closable: true,
    duration: '-1',
  }),
  [DuplicateAmpStarted]: () => ({
    type: 'loading',
    title: 'Amp is being duplicated. It might take a moment. We will notify you when it is ready for use.',
    duration: '6000',
    closable: false,
  }),
  [DuplicateAmpSucceeded]: ({ actions }) => ({
    type: 'success',
    title: 'Amp was successfully duplicated.',
    duration: '-1',
    closable: true,
    actions,
  }),
  [PreviewOnlyAmp]: ({ actions }) => ({
    type: 'default',
    title: 'Preview only',
    duration: '-1',
    closable: false,
    actions,
  }),

  // General
  [CopiedToClipboard]: () => ({
    type: 'success',
    title: 'Copied to clipboard',
  }),
  [MediaUploadFailed]: () => ({
    type: 'warning',
    title: `Failed to upload media`,
    description: 'Max file size is 100MB',
    closable: true,
    duration: '-1',
  }),
  [ResentInvitation]: () => ({
    type: 'info',
    title: 'Invitation was successfully resent',
    duration: '6000',
    closable: false,
  }),
};
